export interface TranslationsMap {
    DE: string;
    DK: string;
    UK: string;
    SE: string;
    NO: string;
    NL: string;
    FI: string;
    FR: string;
}

export interface LocationsMap {
    AFRICA: string;
    ASIA: string;
    LAMA: string;
    USA: string;
    AUSTRALIA: string;
    AMERICA: string;
}

/**
 * @class GlobalSettings
 *
 * All the is* methods could be replaced with proxy, but the proxies lacks of support in IE < 11
 */
export class GlobalSettings {
    public options: GlobalOptions;

    constructor(options: GlobalOptions) {
        this.options = options;
    }

    public static get TRANSLATIONS(): TranslationsMap {
        return {
            DE: 'de',
            DK: 'dk',
            UK: 'uk',
            SE: 'se',
            NO: 'no',
            NL: 'nl',
            FI: 'fi',
            FR: 'fr',
        };
    }

    public static get LOCATIONS(): LocationsMap {
        return {
            AFRICA: 'africa',
            ASIA: 'asia',
            LAMA: 'lama',
            USA: 'usa',
            AUSTRALIA: 'australia',
            AMERICA: 'namerica',
        };
    }

    public static get PAGES() {
        return {
            HOME: 'home',
            DESTINATION: 'destination',
            TOUR: 'tour',
        };
    }

    public get location(): string {
        return this.options.instance.brand;
    }

    public get locationLabel(): string {
        return this.options.instance.brandLabel;
    }

    public get translation(): string {
        return this.options.instance.locale;
    }

    public get currencyCode(): string {
        switch (this.translation) {
            case GlobalSettings.TRANSLATIONS.UK:
                return 'GBP';
            case GlobalSettings.TRANSLATIONS.DK:
                return 'DKK';
            case GlobalSettings.TRANSLATIONS.SE:
                return 'SEK';
            case GlobalSettings.TRANSLATIONS.NO:
                return 'NOK';
            case GlobalSettings.TRANSLATIONS.NL:
            case GlobalSettings.TRANSLATIONS.DE:
            case GlobalSettings.TRANSLATIONS.FI:
                return 'EUR';
            default:
                return '';
        }
    }

    public get isDe(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.DE;
    }

    public get isEd(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.DE;
    }

    public get isDk(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.DK;
    }

    public get isKd(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.DK;
    }

    public get isUk(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.UK;
    }

    public get isKu(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.UK;
    }

    public get isNl(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.NL;
    }


    public get isLn(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.NL;
    }

    public get isNo(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.NO;
    }

    public get isOn(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.NO;
    }

    public get isSe(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.SE;
    }

    public get isEs(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.SE;
    }

    public get isFi(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.FI;
    }

    public get isIf(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.FI;
    }

    public get isFr(): boolean {
        return this.translation === GlobalSettings.TRANSLATIONS.FR;
    }

    public get isAfrica(): boolean {
        return this.location === GlobalSettings.LOCATIONS.AFRICA;
    }

    public get isAsia(): boolean {
        return this.location === GlobalSettings.LOCATIONS.ASIA;
    }

    public get isLama(): boolean {
        return this.location === GlobalSettings.LOCATIONS.LAMA;
    }

    public get isAustralia(): boolean {
        return this.location === GlobalSettings.LOCATIONS.AUSTRALIA;
    }


    public get isUsa(): boolean {
        return this.location === GlobalSettings.LOCATIONS.USA;
    }

    public get isTour(): boolean {
        return this.options.page.controller === GlobalSettings.PAGES.TOUR;
    }

    public get isDestination(): boolean {
        return this.options.page.controller === GlobalSettings.PAGES.DESTINATION;
    }

    public get isHome(): boolean {
        return this.options.page.action === GlobalSettings.PAGES.HOME;
    }
}
